import styled from 'styled-components'

export const StyledCelulasPerformanceTable = styled.div`
  position: relative;
  width: 100%;
`
